import { Component, OnInit, AfterViewInit, NgZone } from '@angular/core';
declare const $: any;
@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css']
})
export class GalleryComponent implements OnInit, AfterViewInit {

  images = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 
    11, 12, 13, 14, 15, 16, 17, 18, 19, 20].map((n) => `/assets/img/pag_grafiche/${n}.PNG`);
//    images = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100,
//      11, 21, 31, 41, 51, 61, 71, 81, 91, 1000].map((n) => `https://picsum.photos/id/${n}/900/500`);
  
  page = 0;
  pageSize = 5;
  selectedIndex = 0;
  constructor(private zone: NgZone) {
  }
  ngAfterViewInit() {
    // $('.carousel').carousel({ pause: true })
    $('.carousel').on('slid.bs.carousel', ($event) => {
      this.setIndex($event);
    });
  }
  private setIndex($event) {
    this.zone.run(() => {
      if ($event && $event['to'])
        this.selectedIndex = $event['to'];
    });
  }
  ngOnInit(): void {
  }
  getImages() {
    let imgPage = Object.assign([], this.images).splice(this.page * this.pageSize, this.pageSize);
    return imgPage;
  }
  setImage(index) {
    this.selectedIndex = index;
  }
}
